import React, {useContext} from "react";
import "./Footer.scss";
import {motion} from "framer-motion";
import emoji from "react-easy-emoji";
import StyleContext from "../../contexts/StyleContext";

export default function Footer() {
  const {isDark} = useContext(StyleContext);
  return (
    <motion.div
      className="footer-div"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      viewport={{ once: true }}
    >
        <p className={isDark ? "dark-mode footer-text" : "footer-text"}>
          {emoji("Made with ❤️ by Jeel Shah")}
        </p>
        <p className={isDark ? "dark-mode footer-text" : "footer-text"}>

          <a
            href="https://github.com/jeelshah911"
            target="_blank"
            rel="noreferrer"
          >

          </a>
        </p>
    </motion.div>
  );
}
